module.exports = __webpack_public_path__ + "static/img/truck_256.8440e19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/truck_256.png
// module id = B33K
// module chunks = 0